export enum Frequency {
  Weekly = 'weekly',
  BiWeekly = 'biweekly',
  TwiceMonthly = 'twicemonthly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  SemiAnnually = 'semiannually',
  Annually = 'annually',
  Once = 'once'
}

export class Recurring {
  public frequency: Frequency = Frequency.Once;
  public startDate: Date = new Date();
  public endDate: Date;
  public count: number;
}
